// extracted by mini-css-extract-plugin
export default {"wb":"wb__XMM6M","wb__wrap":"wb__wrap__IUEqr","wb__title":"wb__title__Yzcf_","wb__close":"wb__close__E31SZ","wb__discl":"wb__discl__BXVsF","wb__content":"wb__content__pLKnR"};